/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { SalesPipelineStage } from "./SalesPipelineStage";
import {
  SalesPipelineStageFromJSON,
  SalesPipelineStageFromJSONTyped,
  SalesPipelineStageToJSON,
  SalesPipelineStageToJSONTyped,
} from "./SalesPipelineStage";
import type { CompanyProblemType } from "./CompanyProblemType";
import {
  CompanyProblemTypeFromJSON,
  CompanyProblemTypeFromJSONTyped,
  CompanyProblemTypeToJSON,
  CompanyProblemTypeToJSONTyped,
} from "./CompanyProblemType";
import type { SalesCallTypeFilter } from "./SalesCallTypeFilter";
import {
  SalesCallTypeFilterFromJSON,
  SalesCallTypeFilterFromJSONTyped,
  SalesCallTypeFilterToJSON,
  SalesCallTypeFilterToJSONTyped,
} from "./SalesCallTypeFilter";

/**
 *
 * @export
 * @interface ListCompaniesByIdsInput
 */
export interface ListCompaniesByIdsInput {
  /**
   *
   * @type {Array<string>}
   * @memberof ListCompaniesByIdsInput
   */
  companyIds: Array<string>;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesByIdsInput
   */
  quotedStartDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesByIdsInput
   */
  quotedEndDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesByIdsInput
   */
  bookedStartDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesByIdsInput
   */
  bookedEndDate?: string | null;
  /**
   *
   * @type {CompanyProblemType}
   * @memberof ListCompaniesByIdsInput
   */
  problemFilter?: CompanyProblemType | null;
  /**
   *
   * @type {SalesPipelineStage}
   * @memberof ListCompaniesByIdsInput
   */
  salesPipelineStageFilter?: SalesPipelineStage | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesByIdsInput
   */
  minEstimatedMonthlyFreightSpend?: number | null;
  /**
   *
   * @type {number}
   * @memberof ListCompaniesByIdsInput
   */
  maxEstimatedMonthlyFreightSpend?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof ListCompaniesByIdsInput
   */
  isOverdueSalesCall?: boolean | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesByIdsInput
   */
  salesCallAuthor?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesByIdsInput
   */
  salesCallStartDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof ListCompaniesByIdsInput
   */
  salesCallEndDate?: string | null;
  /**
   *
   * @type {Array<SalesCallTypeFilter>}
   * @memberof ListCompaniesByIdsInput
   */
  salesCallTypes?: Array<SalesCallTypeFilter> | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ListCompaniesByIdsInput
   */
  locationFilterIdentifiers?: Array<string> | null;
}

/**
 * Check if a given object implements the ListCompaniesByIdsInput interface.
 */
export function instanceOfListCompaniesByIdsInput(
  value: object,
): value is ListCompaniesByIdsInput {
  if (!("companyIds" in value) || value["companyIds"] === undefined)
    return false;
  return true;
}

export function ListCompaniesByIdsInputFromJSON(
  json: any,
): ListCompaniesByIdsInput {
  return ListCompaniesByIdsInputFromJSONTyped(json, false);
}

export function ListCompaniesByIdsInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListCompaniesByIdsInput {
  if (json == null) {
    return json;
  }
  return {
    companyIds: json["companyIds"],
    quotedStartDate:
      json["quotedStartDate"] == null ? undefined : json["quotedStartDate"],
    quotedEndDate:
      json["quotedEndDate"] == null ? undefined : json["quotedEndDate"],
    bookedStartDate:
      json["bookedStartDate"] == null ? undefined : json["bookedStartDate"],
    bookedEndDate:
      json["bookedEndDate"] == null ? undefined : json["bookedEndDate"],
    problemFilter:
      json["problemFilter"] == null
        ? undefined
        : CompanyProblemTypeFromJSON(json["problemFilter"]),
    salesPipelineStageFilter:
      json["salesPipelineStageFilter"] == null
        ? undefined
        : SalesPipelineStageFromJSON(json["salesPipelineStageFilter"]),
    minEstimatedMonthlyFreightSpend:
      json["minEstimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["minEstimatedMonthlyFreightSpend"],
    maxEstimatedMonthlyFreightSpend:
      json["maxEstimatedMonthlyFreightSpend"] == null
        ? undefined
        : json["maxEstimatedMonthlyFreightSpend"],
    isOverdueSalesCall:
      json["isOverdueSalesCall"] == null
        ? undefined
        : json["isOverdueSalesCall"],
    salesCallAuthor:
      json["salesCallAuthor"] == null ? undefined : json["salesCallAuthor"],
    salesCallStartDate:
      json["salesCallStartDate"] == null
        ? undefined
        : json["salesCallStartDate"],
    salesCallEndDate:
      json["salesCallEndDate"] == null ? undefined : json["salesCallEndDate"],
    salesCallTypes:
      json["salesCallTypes"] == null
        ? undefined
        : (json["salesCallTypes"] as Array<any>).map(
            SalesCallTypeFilterFromJSON,
          ),
    locationFilterIdentifiers:
      json["locationFilterIdentifiers"] == null
        ? undefined
        : json["locationFilterIdentifiers"],
  };
}

export function ListCompaniesByIdsInputToJSON(
  json: any,
): ListCompaniesByIdsInput {
  return ListCompaniesByIdsInputToJSONTyped(json, false);
}

export function ListCompaniesByIdsInputToJSONTyped(
  value?: ListCompaniesByIdsInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyIds: value["companyIds"],
    quotedStartDate: value["quotedStartDate"],
    quotedEndDate: value["quotedEndDate"],
    bookedStartDate: value["bookedStartDate"],
    bookedEndDate: value["bookedEndDate"],
    problemFilter: CompanyProblemTypeToJSON(value["problemFilter"]),
    salesPipelineStageFilter: SalesPipelineStageToJSON(
      value["salesPipelineStageFilter"],
    ),
    minEstimatedMonthlyFreightSpend: value["minEstimatedMonthlyFreightSpend"],
    maxEstimatedMonthlyFreightSpend: value["maxEstimatedMonthlyFreightSpend"],
    isOverdueSalesCall: value["isOverdueSalesCall"],
    salesCallAuthor: value["salesCallAuthor"],
    salesCallStartDate: value["salesCallStartDate"],
    salesCallEndDate: value["salesCallEndDate"],
    salesCallTypes:
      value["salesCallTypes"] == null
        ? undefined
        : (value["salesCallTypes"] as Array<any>).map(
            SalesCallTypeFilterToJSON,
          ),
    locationFilterIdentifiers: value["locationFilterIdentifiers"],
  };
}
